import React from 'react';
import * as Fa from 'react-icons/fa';

const MenuRoute = [
  {
    title: 'Dashboard',
    path: '/',
    icon: <Fa.FaHome size={18} />,
    isActive: '',
    action: ['read_only'],
    service: ['nvo.tms.delivery', 'nvo.tms.manifest'],
    isMaster: false,
    isDropdown: false,
  },
  {
    title: 'Orders',
    path: '',
    icon: <Fa.FaFileSignature size={18} />,
    isActive: 'order',
    isMaster: false,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery', 'nvo.tms.contract'],
    isDropdown: true,
    child: [
      {
        title: 'Order List',
        path: '/order',
        isActive: 'order',
        icon: <Fa.FaFileSignature size={17} />,
        action: ['read_only', 'manage'],
        service: 'nvo.tms.delivery',
      },
      {
        title: 'Shipment',
        path: '/order/shipment',
        icon: <Fa.FaTruckMoving size={17} />,
        isActive: 'shipment',
        action: ['read_only', 'manage'],
        service: 'nvo.tms.delivery',
      },
      {
        title: 'Kontrak',
        path: '/order/contract',
        isActive: 'contract',
        icon: <Fa.FaFileSignature size={17} />,
        action: ['read_only', 'manage'],
        service: 'nvo.tms.contract',
      },
      {
        title: 'Customer',
        path: '/order/customer',
        isActive: 'customer',
        icon: <Fa.FaTruckMoving size={17} />,
        action: ['read_only', 'manage'],
        service: 'nvo.tms.delivery',
      },
    ],
  },
  {
    title: 'Manifest',
    path: '/manifest',
    icon: <Fa.FaTasks size={18} />,
    isActive: 'manifest',
    action: ['read_only', 'manage'],
    service: ['nvo.tms.manifest'],
    isMaster: false,
    isDropdown: true,
    child: [
      {
        title: 'Monitoring',
        path: '/manifest/monitoring',
        isActive: 'monitoring',
        icon: <Fa.FaTachometerAlt size={17} />,
        action: ['read_only', 'manage'],
        service: 'nvo.tms.manifest',
        hide: 'sm',
      },
      {
        title: 'Report',
        path: '/manifest',
        icon: <Fa.FaThList size={17} />,
        isActive: 'manifest',
        action: ['read_only'],
        service: 'nvo.tms.manifest',
      },
    ],
  },
  {
    title: 'Invoice',
    path: '/invoice',
    icon: <Fa.FaClipboardList size={18} />,
    isActive: 'invoice',
    action: ['read_only', 'manage'],
    service: ['nvo.tms.invoice'],
    isMaster: false,
    isDropdown: false,
  },
  {
    title: 'Terima',
    path: '/scanner/shipment',
    icon: <Fa.FaBarcode size={18} style={{ marginTop: 2 }} />,
    isActive: 'shipment_scanner',
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
    isMaster: false,
    isDropdown: false,
  },
  {
    title: 'Report',
    path: '/report/manifest',
    icon: <Fa.FaThList size={18} />,
    isActive: 'report',
    isMaster: false,
    isDropdown: true,
    child: [
      {
        title: 'Manifest',
        path: '/report/manifest',
        isActive: 'report_manifest',
        icon: <Fa.FaTasks size={17} />,
        hide: 'sm',
      },
    ],
  },
  {
    title: 'Master Data',
    path: '',
    icon: <Fa.FaLayerGroup size={18} />,
    isActive: 'master',
    isDropdown: true,
    isMaster: true,
    action: ['read_only', 'manage'],
    service: [
      'nvo.platform.location',
      'nvo.tms.driver',
      'nvo.platform.partner',
    ],
    child: [
      {
        title: 'Lokasi',
        path: '/master/location',
        isActive: 'location',
        action: ['read_only', 'manage'],
        service: 'nvo.platform.location',
      },
      {
        title: 'Driver',
        path: '/master/driver',
        isActive: 'driver',
        action: ['read_only', 'manage'],
        service: 'nvo.tms.driver',
      },
      {
        title: 'Customer',
        path: '/master/customer',
        isActive: 'customer',
        action: ['read_only', 'manage'],
        service: 'nvo.platform.partner',
      },
      {
        title: 'Vendor',
        path: '/master/vendor',
        isActive: 'vendor',
        action: ['read_only', 'manage'],
        service: 'nvo.platform.partner',
      },
    ],
  },
  {
    title: 'Pengaturan',
    path: '/setting',
    icon: <Fa.FaTools size={18} />,
    isActive: 'setting',
    isDropdown: false,
    isMaster: true,
    service: [
      'nvo.platform.client',
      'nvo.tms.service',
      'nvo.tms.pricing',
      'nvo.platform.location.hub',
      'nvo.platform.usergroup',
      'nvo.platform.user',
    ],
  },
];

export default MenuRoute;
